import { render, staticRenderFns } from "./BvnVerification.vue?vue&type=template&id=77b85714&scoped=true"
import script from "./BvnVerification.vue?vue&type=script&lang=js"
export * from "./BvnVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b85714",
  null
  
)

export default component.exports